/**
 * @generated SignedSource<<58eff62729950c7d4c9500dea125f7bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDemoInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteDemoMutation$variables = {
  input: DeleteDemoInput;
};
export type deleteDemoMutation$data = {
  readonly deleteDemo: {
    readonly deletedDemoId: string | null;
  } | null;
};
export type deleteDemoMutation = {
  variables: deleteDemoMutation$variables;
  response: deleteDemoMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDemoPayload",
    "kind": "LinkedField",
    "name": "deleteDemo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedDemoId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDemoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDemoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0bb39d25ab7a1c40d4d8f4a4f50694ac",
    "id": null,
    "metadata": {},
    "name": "deleteDemoMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDemoMutation(\n  $input: DeleteDemoInput!\n) {\n  deleteDemo(input: $input) {\n    deletedDemoId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e320050ebacdeecdbf6b70346fedb922";

export default node;
